<template>
  <div>
    <!-- Header -->

    <!-- Page content -->
    <b-container class="py-7 py-lg-8 pt-lg-9">
      <!-- Table -->
      <b-row class="justify-content-center">
        <b-col lg="6" md="8" sm="12">
          <b-card no-body class="bg-secondary border-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <b-row>
                <b-col lg="12">
                  <b-card no-body class="mb-1 mt-3">
                    <b-card-header
                      header-tag="header"
                      href="#"
                      role="tab"
                      v-b-toggle.accordion-1
                    >
                      <h5 class="mb-0">
                        รายละเอียดผู้ใช้งาน
                      </h5>
                    </b-card-header>
                    <b-collapse
                      id="accordion-1"
                      visible
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <p>ชื่อ นามสกุล : นายสมชาย ศรีสมรรร</p>
                        <p>หมายเลขบัตรประชาชน : 1710500311233</p>
                        <p>วันเดือนปีเกิด : 21/07/2022</p>
                        <p>เบอร์โทรศัพท์ : 0909090090</p>
                        <p>
                          ที่อยู่ : 98 68 หมู่7 ตำบล บางบัวทอง อำเภอบางบัวทอง
                          นนทบุรี 11110
                        </p>
                      </b-card-body>
                    </b-collapse>
                  </b-card>

                  <b-card no-body class="mb-1">
                    <b-card-header
                      header-tag="header"
                      href="#"
                      role="tab"
                      v-b-toggle.accordion-2
                    >
                      <h5 class="mb-0">
                        ข้อมูลการขับขี่
                      </h5>
                    </b-card-header>
                    <b-collapse
                      id="accordion-2"
                      visible
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <p>หมายเลขบัตรใบขับขี่ : 09090232323</p>
                        <p>ประเภท :</p>
                        <p>วันหมดอายุ :</p>
                      </b-card-body>
                    </b-collapse>
                    <b-card-header
                      header-tag="header"
                      href="#"
                      role="tab"
                      v-b-toggle.accordion-3
                    >
                      <h5 class="mb-0">
                        ข้อมูลการทำงาน
                      </h5>
                    </b-card-header>
                    <b-collapse
                      id="accordion-3"
                      visible
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <p>วันที่เริ่มทำงาน : 20/05/2023</p>
                        <p>สถานการทำงาน : ปกติ</p>
                        <p>วันที่เริ่มหักประกัน : 20/05/2023</p>
                        <p>เงินค้ำประกัน :500 บาท</p>
                        <p>ทีม : MKT</p>
                        <p>ผู้ควบคุมทีม : เมธา ฟ้าแว๊ปๆ</p>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </b-col>
              </b-row>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      model: {
        email: "",
        password: "",
        rememberMe: false,
      },
    };
  },
  methods: {
    onSubmit() {
      // this will be called only after form is valid. You can do api call here to login
    },
  },
};
</script>
